import ApiClient from "./ApiClient"

import {PersonGroupLockingSystemPermissionAdd} from "../types/PersonGroupLockingSystemPermission"

export const PersonGroupLockingSystemPermissionApi = {

    apiPath: 'person-group-locking-system-permissions',

    endpoint: (param: string = ''): string => {
        return param
            ? PersonGroupLockingSystemPermissionApi.apiPath + '/' + param
            : PersonGroupLockingSystemPermissionApi.apiPath
    },

    add: async (personGroupLockingSystemPermissions: PersonGroupLockingSystemPermissionAdd): Promise<any> => {

        const result = await ApiClient.post(
            'person-groups/' + personGroupLockingSystemPermissions.personGroupId + '/locking-system-permissions',
            personGroupLockingSystemPermissions
        )

        return result.data?.data
    },

    delete: async (personGroupId: number, lockingSystemPermissionId: number): Promise<void> => {

        return await ApiClient.delete(
            'person-groups/' + personGroupId + '/locking-system-permissions/' + lockingSystemPermissionId
        )

    },

    deleteAll: async (personGroupId: number): Promise<any> => {

        return await ApiClient.delete('person-groups/' + personGroupId + '/locking-system-permissions/all')

    },

}

export default PersonGroupLockingSystemPermissionApi